import type { Platform } from "../domain/types";

export interface AffiliateLinkValidation {
  valid: boolean;
  reason: string;
}

export function validateAffiliateLink(
  platform: Platform,
  value: string,
  trackingId = "",
): AffiliateLinkValidation {
  const code = platform.referralCode.trim();
  if (!code) {
    return {
      valid: false,
      reason: `Cadastre primeiro o código de afiliada da ${platform.name}.`,
    };
  }

  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return { valid: false, reason: "Informe um link completo e válido." };
  }

  const hostname = url.hostname.toLowerCase();
  const expectedHost =
    platform.slug === "amazon"
      ? "amazon."
      : platform.slug === "temu"
        ? "temu."
        : platform.slug === "shein"
          ? "shein."
          : "";
  if (expectedHost && !hostname.includes(expectedHost)) {
    return {
      valid: false,
      reason: `Este endereço não pertence à ${platform.name}.`,
    };
  }

  const normalizedCode = code.toLowerCase();
  const normalizedValue = decodeURIComponent(url.toString()).toLowerCase();
  const normalizedTracking = trackingId.trim().toLowerCase();
  if (platform.slug === "amazon") {
    const tag = url.searchParams.get("tag")?.toLowerCase();
    return tag === normalizedCode
      ? { valid: true, reason: "Partner Tag confirmado no link." }
      : {
          valid: false,
          reason: `O parâmetro tag precisa ser ${code}.`,
        };
  }

  if (
    normalizedValue.includes(normalizedCode) ||
    normalizedTracking === normalizedCode
  ) {
    return {
      valid: true,
      reason:
        platform.slug === "shein"
          ? "Código e domínio SHEIN confirmados. Use somente links gerados na central de afiliados."
          : "Código de afiliada confirmado no link.",
    };
  }

  return {
    valid: false,
    reason: `O link ou tracking precisa conter o código ${code}.`,
  };
}
